function dropHandler(ev, placeholderId, invalidBannerId, invalidSizeId, maxFileSize) {
	
	const id = "ficheros";
	const idTemp = "ficherosTemp";
    const placeholder = document.getElementById(placeholderId);
    const invalidBanner = document.getElementById(invalidBannerId);
    const invalidSize = document.getElementById(invalidSizeId);
    const myFile = document.getElementById(id);
    const myFileTemp = document.getElementById(idTemp);
    
    const files = [];
    const items = [];
    
    if(ev instanceof DragEvent) {
    	ev.preventDefault();
    	if(ev.dataTransfer.items && ev.dataTransfer.items.length !== 0) {
    		items.push(...ev.dataTransfer.items);
    	}
    } else if(ev.target.files && ev.target.files.length !== 0) {
    	items.push(...ev.target.files);
    	ev.preventDefault();
    }
    
    if (items && items.length != 0) {
    	const dT = new DataTransfer();
    	for (var i = 0; i < items.length; i++) {
    		if(ev instanceof DragEvent) {
    			const element = items[i];
    			if (element.kind === 'file') {
    				const file = element.getAsFile();
    				if(validateFileType(file) && validateFileSize(file, maxFileSize)) {
    					dT.items.add(file);
    					files.push(file);
    					invalidBanner.classList.add('hide');
    				} else {
    					if (!validateFileType(file)) {
    						invalidBanner.classList.remove('hide');
    						invalidBanner.classList.remove('wrong');
    						setTimeout(function(){ invalidBanner.classList.add('wrong'); invalidBanner.classList.add('hide'); }, 20);
    					} else if (!validateFileSize(file, maxFileSize)) {
    						invalidSize.classList.remove('hide');
    						invalidSize.classList.remove('wrong');
    						setTimeout(function(){ invalidSize.classList.add('wrong'); invalidSize.classList.add('hide'); }, 20);
    					}
    				}
    			}
    		} else {
    			const file = items[i];
    			if(validateFileType(file) && validateFileSize(file, maxFileSize)) {
    				dT.items.add(file);
    				files.push(file);
    				invalidBanner.classList.add('hide');
    			} else {
    				if (!validateFileType(file)) {
    					invalidBanner.classList.remove('hide');
    					invalidBanner.classList.remove('wrong');
    					setTimeout(function(){ invalidBanner.classList.add('wrong'); invalidBanner.classList.add('hide'); }, 20);
    				} else if (!validateFileSize(file, maxFileSize)) {
    					invalidSize.classList.remove('hide');
    					invalidSize.classList.remove('wrong');
    					setTimeout(function(){ invalidSize.classList.add('wrong'); invalidSize.classList.add('hide'); }, 20);
    				}
    			}
    		}
    	}
    	
    	//Añadimos los "ficheros" que ya había en el área, para que no se pierdan
    	if(ev instanceof DragEvent) {
	    	Array.from(myFile.files).forEach(file => {
	    			dT.items.add(file);
	    			files.push(file);
		    });
    	} else {
    		Array.from(myFileTemp.files).forEach(file => {
    			dT.items.add(file);
    			files.push(file);
    		});
    	}
    			    	
		myFile.files = dT.files;
		myFileTemp.files = dT.files;
    }

    if(files.length !== 0) placeholder.classList.add("hide");
    const filesDiv = document.getElementById('ficherosList');
    if(files.length !== 0) filesDiv.innerHTML = '';
    files.forEach(file => {
    	let baseFile;
    	if(file.type.startsWith('image/')) {
    		const reader = new FileReader();
    		baseFile = document.getElementById('fileDeleteBase').cloneNode(true);
    		reader.onload = function() {
    			const img = document.createElement('img');
    			img.src = reader.result;
    			baseFile.insertBefore(img, baseFile.childNodes[0]);
    		};
    		reader.readAsDataURL(file);
    	} else baseFile = document.getElementById('fileDeleteDocumentBase').cloneNode(true);
    	
    	baseFile.removeAttribute('id');
    	baseFile.innerHTML = baseFile.innerHTML.replaceAll('{fileName}', file.name).replaceAll('{fileList}', id).replaceAll('{placeholder}', placeholderId);
    	filesDiv.append(baseFile);
    });
}

function dragOverHandler(ev) {
	ev.preventDefault();
	ev.stopPropagation();
}

function deleteFile(event, fileName, fileList, placeholderId) {
	event.preventDefault();
    const placeholder = document.getElementById(placeholderId);
	const myFile = document.getElementById(fileList);
	const myFileTemp = document.getElementById("ficherosTemp");
	const filterFiles = Array.from(myFileTemp.files).filter(file => file.name !== fileName);
	const dT = new DataTransfer();
	if (filterFiles.length==0) placeholder.classList.remove("hide");
	filterFiles.forEach(file => dT.items.add(file));
	myFile.files = dT.files;
	myFileTemp.files = dT.files;
	event.srcElement.parentElement.remove()
}

function validateFileType(file) {
	if(file.type.startsWith('image/') || file.name.endsWith('.pdf')) return true;
	else return false;
}

function validateFileSize(file, maxFileSize) {
	if (file.size<maxFileSize) return true;
    else return false;
}
